<template>
    <div>
        <!--销售历史-->
        <header class="form-title">
            <Row>
                <Col span="22">
                    <Form inline :label-width="80">
                        <FormItem label="选择时间">
                            <DatePicker
                                    split-panels
                                    type="daterange"
                                    :options="options"
                                    placeholder="选择日期"
                                    @on-change="modifyTime"
                                    :value="valuedate"
                            >
                            </DatePicker>
                        </FormItem>


                        <FormItem prop="dynamic" label="客户">
                            <el-popover
                                placement="bottom"
                                width="240"
                                ref="customerPopover"
                                @show="dynamicCustomerShow"
                                @hide="dynamicCustomerHide"
                                popper-class="dynamic-selector-popover"
                                trigger="manual">
                                
                                <ul class="customer-list">
                                <li v-for="customer in filterCustomerList" :key="customer.id" :v-if="customer.isdel != 0" @click="selectCustomer(customer)">
                                    <span v-if="customer.customerType == 1 && !customer.disabled" style="color: #ff5e5e">{{`${customer.name} ${customer.phone || ""}`}}</span> 
                                    <span v-if="customer.customerType == 0 && !customer.disabled" style="color: #2d8cf0">{{`${customer.name} ${customer.phone || ""}`}}</span> 
                                    <span v-if="customer.customerType == null && !customer.disabled">{{`${customer.name} ${customer.phone || ""}`}}</span> 
                                </li>

                                <li v-if="isLoadMoreBtnShow()">
                                    <div class="load-mote-customer-content" @click="loadMoreCurstomer">
                                    <span v-if="isCallCustomerApi" class="el-icon-loading"></span>
                                    <span v-else>加载更多</span>
                                    </div>
                                </li>

                                <li v-if="isNoDataShow()">
                                    <div class="no-data-msg">空空如也 没有数据</div>
                                </li>
                                </ul>

                                <div slot="reference" @click="showDynamicCustomerList" class="dynamic-customer">
                                    <el-Input size="small" class="formSelect-input" v-if="isDynamicSearchShow" v-model="customerSearchTxt" />
                                    <el-Input size="small" class="formSelect-input" v-else :value="selectedUserName" />
                                    <span :class="`el-icon-arrow-up dynamic-custoer-search-arrow ${isDynamicListShow ? 'up' : 'down'}`"></span>
                                </div>
                            </el-popover>
                        </FormItem>

                        <FormItem label="员工">
                            <Select v-model="sendData.staff" filterable style="width: 200px">
                                <Option value="">全部</Option>
                                <Option :value="k.id" v-for="(k,v) in adminList" v-if="k.isdel==0" :key="v">{{k.name}}
                                </Option>
                            </Select>
                        </FormItem>
                        <FormItem label="店铺" v-if="isCustomerSharing==1">
                            <Select v-model="sendData.shopName" filterable style="width: 200px">
                                <Option
                                        v-if="k.isCustomerSharing==1 || k.isgeneralwarehouse=='Y'"
                                        :value="k.id"
                                        v-for="(k,v) in shopList"
                                        :key="v">{{k.name}}</Option>
                            </Select>
                        </FormItem>
                        <FormItem label="单号">
                            <Input v-model="sendData.code" style="width: 200px"/>
                            <Button type="primary" style="margin-left: 15px" @click="searchCondition">搜索</Button>
                        </FormItem>
                    </Form>
                </Col>
                <Col span="2">
                    <Button type="primary" style="position: relative;top: -10px;right: 26px"
                            @click="$router.push({path:'/newSale'})">
                        <Icon type="md-add"/>
                        添加销售单
                    </Button>
                </Col>
            </Row>
        </header>
        <section>
            <Card class="historyItem"
                  :dis-hover="false"
                  v-for="(item, index) in pageData"
                  :key="index"
                  @click.native="$router.push({path:'/salesListDetail',query:{id:item.id}})"

            >
                <p slot="title" style="color: #ffaf5e" v-if="item.state==1&&item.inferiorFlag == 0">{{item.customer.name}}</p>
                <p slot="title" style="color: #5ed9ff" v-if="item.state==1&&item.inferiorFlag == 1">{{item.customer.name}}</p>

                <p slot="title" style="color: #46bab2" v-if="item.state ==2">{{item.customer.name}}</p>
                <span slot="extra" class="typeitem typeitems" v-if="item.state==1&&item.inferiorFlag == 0">销售单</span>
                <span slot="extra" class="typeitem typeitemsInferior" v-if="item.state==1&&item.inferiorFlag == 1">销售残次品单</span>

                <span slot="extra" v-if="item.state ==2" class="typeitem">网销单</span>
                <ul class="type-content">
                    <li> 实收金额：￥{{item.money}}</li>
                    <li> 商品数量：{{item.total}}</li>
                    <li> 建立时间：{{item.time}}</li>
                    <li> 订单号码：{{item.markcode}}</li>
                </ul>
                <p class="ywy">业务员：{{item.adminName}}</p>
            </Card>
        </section>
        <div class="pageTotal">
            <Page :total="page.total"
                  show-total
                  :page-size="page.rows"
                  @on-change="onGongPageTotal"/>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                cid: '',
                sid: '',
                shopList: [],//店铺列表
                customerList: [],//客户列表
                customerSearchTxt: "",
                allCustomerCount: 0, 
                allCustomerCountUnderFilter: 0, 
                isDynamicSearchShow: false,
                selectedUserName: "",
                customerPageObj: {
                    "noSearch": 1
                },
                loadMoreBtnStatusObj: {
                    "noSearch": "show"
                },
                isCallCustomerApi: false,
                isDynamicListShow: false,
                custSearchDate:{
                    page:1,
                    rows: 1000,
                    name:null,
                    phone:null
                },
                adminList: [],//员工列表
                pageData: [],
                options: {
                    shortcuts: [
                        {
                            text: '昨日',
                            value() {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
                                return [start, start];
                            },
                        },
                        {
                            text: '今日',
                            value() {
                                const end = new Date();
                                const start = new Date();
                                return [start, end];
                            },
                        },
                        {
                            text: '近七日',
                            value() {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                                return [start, end];
                            },

                        }
                    ],
                },
                sendData: {
                    customer: '',
                    staff: '',
                    code: '',
                    shopName: ''
                },
                page: {
                    total: 0,
                    page: 1,
                    rows: 12
                },
                isCustomerSharing:0, //客户共享是否开启 0关 1开
            };
        },
        activated(){
            if(sessionStorage.getItem("updateSalesListFlag") == 1){
                sessionStorage.setItem("updateSalesListFlag",2);
                this.getMarketList(this.page.page, this.page.rows, this.valuedate[0], this.valuedate[1]);
            }
        },        
        created: function () {
            this.bindCloseDynamicSelectPopover();
            //获取用户信息
            this.cid = JSON.parse(localStorage.getItem('shop')).cid
            this.sid = JSON.parse(localStorage.getItem('shop')).id
            this.isCustomerSharing = JSON.parse(localStorage.getItem('shop')).isCustomerSharing
            this.valuedate[0] = this.fun_date(-30)
            this.valuedate[1] = this.nowTime
            this.getMarketList(this.page.page, this.page.rows, this.valuedate[0], this.valuedate[1])
            this.getCustomerList(true)
            this.getAdminList()
            this.getShopList()
        },
        computed: {
            filterCustomerList() {
                if (this.isDynamicSearchShow && this.customerSearchTxt !== "") {
                    return this.customerList.filter(user => {
                    let tempName = user.name || "";
                    let tempPhone = user.phone || "";
                    return tempName.includes(this.customerSearchTxt) || tempPhone.includes(this.customerSearchTxt);
                    });
                }

                return this.customerList;      
            }
        },
        watch: {
            'sendData.customer': {
                deep: true,
                handler: function (newVal, oldVal) {
                    this.getMarketList(this.page.page, this.page.rows, this.valuedate[0], this.valuedate[1])

                    let selectedCustomer = this.customerList.find(user => this.sendData.customer === user.id) || {};
                    this.selectedUserName = selectedCustomer.name || "";
                }
            },
            'sendData.staff': {
                deep: true,
                handler: function (newVal, oldVal) {
                    this.getMarketList(this.page.page, this.page.rows, this.valuedate[0], this.valuedate[1])
                }
            },
            'sendData.code': {
                deep: true,
                handler: function (newVal, oldVal) {
                    this.getMarketList(this.page.page, this.page.rows, this.valuedate[0], this.valuedate[1])
                }
            },
            'sendData.shopName': {
                deep: true,
                handler: function (newVal, oldVal) {
                    this.sid = newVal
                    this.getMarketList(this.page.page, this.page.rows, this.valuedate[0], this.valuedate[1])
                }
            },
        },
        methods: {

            //获取采购单
            getMarketList(page, rows, startTime, endTime) {
                this.$Api.getMarketList({
                    cid: this.cid,
                    sid: this.sid,
                    page: page,
                    rows: rows,
                    time: startTime,
                    endtime: endTime,
                    customerid: this.sendData.customer,
                    markcode: this.sendData.code,
                    adminid: this.sendData.staff,
                    url: '',
                    status: 0,
                    state: 1,


                }).then(res => {
                    if (res.code == 200) {
                        this.page.total = res.count
                         this.pageData = res.data
                    } else {
                        this.$Message.warning(res.msg);
                    }
                });

            },
            loadMoreCurstomer() {
                this.getCustomerPage();
                this.getCustomerList(false);
            },
            getLoadMoreStatusObj(resDataLength) {
                if (this.customerSearchTxt === "") {
                    this.loadMoreBtnStatusObj["noSearch"] = this.customerList.length < this.allCustomerCount ? "show" : "hide";
                } else {
                    let pageKey = this.customerSearchTxt;
                    if (resDataLength === 0) {
                    this.loadMoreBtnStatusObj[pageKey] = "hide";
                    } else {
                    this.loadMoreBtnStatusObj[pageKey] = this.filterCustomerList.length < this.allCustomerCountUnderFilter ? "show" : "hide";
                    }
                }
            },
            mergeNewDataIntoCustomerList(newCustomerData) {
                let allIdInCustomerList = this.customerList.map(customer => customer.id);
                let newCustomerList = JSON.parse(JSON.stringify(this.customerList));
                newCustomerData.forEach(customer => {
                    if (!allIdInCustomerList.includes(customer.id)) {
                    newCustomerList.push(customer);
                    }
                });
                this.customerList = newCustomerList;
            },
            getCustomerPage() {
                if (this.customerSearchTxt === "") {
                    this.customerPageObj["noSearch"]++;
                    this.custSearchDate.page = this.customerPageObj["noSearch"];
                } else {
                    let pageKey = this.customerSearchTxt;
                    this.customerPageObj[pageKey] = this.customerPageObj[pageKey] || 0;
                    this.customerPageObj[pageKey]++;
                    this.custSearchDate.page = this.customerPageObj[pageKey];
                }
            },
            isLoadMoreBtnShow() {
                if (this.loadMoreBtnStatusObj["noSearch"] === "hide") {
                    return false;
                }
                
                if (this.customerSearchTxt === "") {
                    return this.loadMoreBtnStatusObj["noSearch"] !== "hide";
                }

                let pageKey = this.customerSearchTxt;

                if (this.loadMoreBtnStatusObj[pageKey] === "hide") {
                    return false;
                }
                if (this.loadMoreBtnStatusObj[pageKey] === "show") {
                    return true;
                }

                // 如果输入2256不需要加载更多按钮，那么输入22562, 22563, 12256等条件，也不需要加载更多
                for (let txtKey in this.loadMoreBtnStatusObj) {
                    if (this.loadMoreBtnStatusObj[txtKey] === "hide" && this.customerSearchTxt.includes(txtKey)) {
                    return false;
                    }
                }
                
                return true;
            },
            isNoDataShow() {
                if (!this.isLoadMoreBtnShow() && this.filterCustomerList.length === 0) {
                    return true;
                }

                return false;
            },
            //客户列表
            getCustomerList(isFirstCallApi) {
                this.$Api.getCustomerListNew({
                    cid: this.cid,
                    sid: this.sid,
                    page: this.custSearchDate.page,
                    rows: this.custSearchDate.rows,
                    name: this.customerSearchTxt,
                    phone: this.customerSearchTxt,          
                    isdel: 1
                }).then(res => {
                    if (res.code == 200) {

                        this.allCustomerCountUnderFilter = res.count || 0;
                        if (this.customerSearchTxt === "") {
                            this.allCustomerCount = res.count || 0;
                        }

                        if (isFirstCallApi) {
                            this.customerList = res.data
                        } else {
                            this.mergeNewDataIntoCustomerList(res.data);
                        }

                        this.getLoadMoreStatusObj(res.data.length);
                        this.isCallCustomerApi = false;
                        
                    } else {
                        this.$Message.warning(res.msg);
                    }
                });
            },
            //员工列表
            getAdminList() {
                this.$Api.getAdminList({
                    cid: this.cid,
                    sid: this.sid,
                    page: 1,
                    rows: 1000,
                }).then(res => {
                    if (res.code == 200) {
                        this.adminList = res.data
                    } else {
                        this.$Message.warning(res.msg);
                    }
                });
            },

            //店铺列表
            getShopList() {
                var data = {
                    cid: this.cid,
                    page: 1,
                    rows: 1000,
                };
                this.$Api.getShopList(data).then(res => {
                    this.shopList = res.data;
                    this.sendData.shopName = JSON.parse(localStorage.getItem('shop')).id

                });
            },

            modifyTime(time) {
                this.valuedate[0] = time[0]
                this.valuedate[1] = time[1]
                this.getMarketList(this.page.page, this.page.rows, this.valuedate[0], this.valuedate[1])
            },
            onGongPageTotal(num) {
                this.getMarketList(num, this.page.rows, this.valuedate[0], this.valuedate[1])
            },
            searchCondition() {
                this.getMarketList(this.page.page, this.page.rows, this.valuedate[0], this.valuedate[1])
            },

            showDynamicCustomerList() {
                this.$refs.customerPopover.doShow();
                this.isDynamicListShow = true;
            },
            hideDynamicCustomerList() {
                this.$refs.customerPopover.doClose();
                this.isDynamicListShow = false;
            },
            selectCustomer(customer) {
                this.sendData.customer = customer.id;
                this.selectedUserName = customer.name;
                this.$refs.customerPopover.doClose();
                this.isDynamicListShow = false;
            },
            dynamicCustomerShow() {
                this.isDynamicSearchShow = true;
            },
            dynamicCustomerHide() {
                this.isDynamicSearchShow = false;
            },
            bindCloseDynamicSelectPopover() {
                let _this = this;
                function closeDynamicEvent(e) {
                if (!["/changShop", "/newSale", "/salesList"].includes(_this.$route.path)) {
                    document.removeEventListener("click", closeDynamicEvent);
                }
                
                try {
                    let parentClass = e.target.parentElement.parentElement.className;
                    if (!parentClass.includes("dynamic-customer") && _this.$refs.customerPopover) {
                    _this.$refs.customerPopover.doClose();
                    _this.isDynamicListShow = false;
                    }
                } catch (err) {
                    // do nothing
                }
                }
                
                document.addEventListener("click", closeDynamicEvent);
            }    
            
        }
    };
</script>

<style lang="scss" scoped>
    .form-title {

        line-height: 54px;
        border-bottom: 1px solid #d9d9d9;
        margin-bottom: 20px;
    }

    .historyItem {
        width: 450px;
        height: 240px;
        background-color: #ffffff;
        box-shadow: 0px 3px 10px 0px rgba(24, 54, 129, 0.14);
        border-radius: 10px;
        display: inline-block;
        margin: 18px;
        cursor: pointer;

        .typeitem {
            display: block;
            width: auto;
            padding: 0 10px;
            height: 30px;
            text-align: center;
            line-height: 30px;
            background-color: #e5fff7;
            border-radius: 4px;
            border: solid 1px #46bab2;
            position: relative;
            top: -3px;
            right: -3px;
            color: #46bab2;
        }

        .typeitems {
            background-color: #fff2e5;
            border: solid 1px #ffaf5e;
            color: #ffaf5e;
        }
        .typeitemsInferior {
            background-color: #5ed9ff3d;
            border: solid 1px #5ed9ff;
            color: #5ed9ff;
        }


        .type-content {
            li {
                height: 30px;
            }
        }

        .ywy {
            text-align: right;
            padding-top: 10px;
        }
    }
    
    .customer-list {
    height: fit-content;
    max-height: 400px;
    overflow: auto;
    }

    .customer-list li {
    min-height: 34px;
    cursor: pointer;
    padding: 0 10px;
    display: flex;
    align-items: center;
    }

    .customer-list li:hover {
    background-color: #F5F7FA;
    }

    .no-data-msg {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.8rem;
    letter-spacing: 0.08rem;
    text-align: center;
    width: 100%;
    }
</style>


<style lang="css">

    .customer-option.el-select-dropdown__item.is-disabled {
      color: #606266;
      cursor: pointer;
      display: list-item !important;
    }
  
    .load-mote-customer-content {
      background: #2d8cf0;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 29px;
      border-radius: 4px;
      color: #fff;
    }
  
    .customer-list::-webkit-scrollbar {
      width: 5px;
    }
  
    .customer-list::-webkit-scrollbar-track {
      border-radius: 10px;
    }
  
    .customer-list::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background: rgba(0,0,0,0.1);
    }
  
    .dynamic-selector-popover {
      padding: 10px 0;
    }
  
      .dynamic-customer {
      position: relative;
    }
  
    .dynamic-custoer-search-arrow {
      position: absolute;
      right: 5px;
      top: 50%;
      color: #C0C4CC;
      transition: 0.5s tranform;
    }
  
    .dynamic-custoer-search-arrow.down {
      transform: translate(0px, -50%) rotate(180deg);
    }
  
    .dynamic-custoer-search-arrow.up {
      transform: translate(0px, -50%) rotate(0deg);
    }
    
    
  </style>